import templateOnly from '@ember/component/template-only';
import { or } from 'ember-truth-helpers';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const DropdownDivider = setComponentTemplate(precompileTemplate("\n  {{#if (or (has-block) @label)}}\n    <div class=\"semeia-dropdown ui dividing header\" ...attributes>\n      {{#if (has-block)}}\n        {{yield}}\n      {{else}}\n        {{@label}}\n      {{/if}}\n    </div>\n  {{else}}\n    <div class=\"divider\"></div>\n  {{/if}}\n", {
  strictMode: true,
  scope: () => ({
    or
  })
}), templateOnly(undefined, "divider:DropdownDivider"));
export default DropdownDivider;